export const environment = {
  production: false,
  apiUrl: 'https://asistente-ia.zeventee.com/webhook/'
};